import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14.4",
  height: "18",
  viewBox: "0 0 14.4 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Group" }, [
      _createElementVNode("path", {
        id: "Vector",
        d: "M0 18V0H1.8V1.8H14.4L12.6 6.3L14.4 10.8H1.8V18H0ZM8.0217 7.5717C8.3739 7.2189 8.55 6.795 8.55 6.3C8.55 5.805 8.3739 5.3814 8.0217 5.0292C7.6695 4.677 7.2456 4.5006 6.75 4.5C6.2544 4.4994 5.8308 4.6758 5.4792 5.0292C5.1276 5.3826 4.9512 5.8062 4.95 6.3C4.9488 6.7938 5.1252 7.2177 5.4792 7.5717C5.8332 7.9257 6.2568 8.1018 6.75 8.1C7.2432 8.0982 7.6671 7.9221 8.0217 7.5717ZM1.8 9H11.745L10.665 6.3L11.745 3.6H1.8V9Z",
        fill: "currentColor"
      })
    ], -1)
  ]))]))
}
export default { render: render }